import { DTMF, MediaConstraints, RTCSession } from '@wui/jssip/lib/RTCSession'

type DTMFMapKey = string

const ofDTMFMapKey = (tone: DTMF['tone'], duration: DTMF['duration']): DTMFMapKey => {
  return `${tone}${duration}`
}

const DTMF_MEDIA_CONSTRAINTS_DELAY_MS = 600

const mediaConstraintsDTMFMap: Map<DTMFMapKey, MediaConstraints> = new Map([
  [ofDTMFMapKey('D', 590), { audio: true }],
  [ofDTMFMapKey('D', 591), { audio: false }],
  [ofDTMFMapKey('D', 592), { video: true }],
  [ofDTMFMapKey('D', 593), { video: false }],
])

export const parseMediaConstraintsFromDTMF = (dtmf: Pick<DTMF, 'duration' | 'tone'>): MediaConstraints | undefined => {
  const { duration, tone } = dtmf
  return mediaConstraintsDTMFMap.get(ofDTMFMapKey(tone, duration))
}

export const sendDTMFMediaConstraintsToSession = (
  session: RTCSession,
  constraints: Pick<MediaConstraints, 'audio'> | Pick<MediaConstraints, 'video'>,
): Promise<boolean> => {
  return new Promise((resolve) => {
    let result = false
    if ('audio' in constraints) {
      session.sendDTMF('D', {
        duration: constraints.audio ? 590 : 591,
      })
      result = true
    } else if ('video' in constraints) {
      session.sendDTMF('D', {
        duration: constraints.video ? 592 : 593,
      })
      result = true
    }
    setTimeout(() => {
      resolve(result)
    }, DTMF_MEDIA_CONSTRAINTS_DELAY_MS)
  })
}
